<template>
  <el-dialog :visible.sync="visible" width="min(1100px, calc(100vw - 24px))" :close-on-click-modal="false" append-to-body @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="readonly && form.id" class="doc-dialog-actions">
          <el-button-group>
            <workflow-doc-buttons biz-type="payment" :biz-id="form.id" perm="finance:payment" :approve-status="String(form.approveStatus || '0')" @approve="approve(form, true)" @unapprove="approve(form, false)" @done="onWorkflowDone" />
            <el-button v-if="isAuth('finance:payment:update') || isAuth('finance:payment:save')" type="primary" size="small" :disabled="!canEditDoc" @click="editFromView">修改</el-button>
            <el-button v-if="isAuth('finance:payment:delete') || isAuth('finance:payment:save')" type="danger" size="small" :disabled="!canEditDoc" @click="deleteFromView">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <el-alert v-if="invalidSourceCount" class="source-warning" title="核销来源异常，请移除相关明细并重新选择" type="warning" show-icon :closable="false" />
    <el-form ref="dataForm" :model="form" :rules="readonly ? {} : formRules" :validate-on-rule-change="false" :disabled="readonly" label-width="90px">
      <el-row :gutter="16">
        <el-col :xs="24" :sm="12" :md="8" :lg="6"><el-form-item label="付款单号" prop="code"><el-input v-model="form.code" :readonly="codeReadonly || !!form.id" :placeholder="codeReadonly ? '保存时自动生成' : ''" /></el-form-item></el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="付款日期" prop="bizDate">
            <el-date-picker v-model="form.bizDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8">
          <el-form-item label="供应商" prop="supplierId">
            <el-input :value="form.partnerName" readonly placeholder="请选择供应商">
              <el-button v-if="!readonly" slot="append" @click="picker = true">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="!readonly || (form.lines && form.lines.length)" :xs="24" :sm="12" :md="8" :lg="4"><el-form-item label="核销合计"><span>{{ writeOffTotal }}</span></el-form-item></el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :xs="24" :sm="12" :md="12" :lg="6">
          <el-form-item label="付款金额" prop="money">
            <el-input-number v-model="form.money" :min="0" :precision="2" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6"><el-form-item label="结算方式"><DictSelectWithAdd v-model="form.settleType" dict-type="SETTLE_TYPE" :disabled="readonly" add-text="新增结算方式" /></el-form-item></el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6"><el-form-item label="付款账户"><DictSelectWithAdd v-model="form.accountName" dict-type="PAYMENT_ACCOUNT" :disabled="readonly" add-text="新增付款账户" /></el-form-item></el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6">
          <el-form-item label="折让">
            <el-input-number v-model="form.discountMoney" :min="0" :precision="2" :disabled="!Number(form.discountMoney || 0)" style="width:100%" />
            <div class="discount-hint">暂未接入核销与记账</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16"><el-col :xs="24" :sm="12"><el-form-item label="入账科目" prop="cashSubjectId">
        <el-select v-model="form.cashSubjectId" filterable style="width:100%" placeholder="请选择与结算方式对应的末级科目">
          <el-option v-for="s in cashSubjects" :key="s.financeSubjectId" :label="s.subjectCode + ' ' + s.subjectName" :value="s.financeSubjectId" />
        </el-select>
      </el-form-item></el-col></el-row>
      <div v-if="!readonly" style="margin-bottom:8px"><el-button type="primary" size="small" :disabled="!form.supplierId" @click="writeoff = true">选择核销</el-button></div>
      <el-table v-if="!readonly || (form.lines && form.lines.length)" border :data="form.lines" :header-cell-style="headStyle">
        <el-table-column type="index" label="序号" width="55" align="center" />
        <el-table-column prop="billCode" label="单号" min-width="150" />
        <el-table-column prop="materialName" label="物料" min-width="140" />
        <el-table-column prop="remainAmount" label="可核销" width="110" align="right">
          <template slot-scope="scope"><span v-if="scope.row.sourceInvalid" class="source-error">来源异常</span><span v-else>{{ scope.row.remainAmount }}</span></template>
        </el-table-column>
        <el-table-column label="核销金额" width="160">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.writeOffMoney" :min="0" :precision="2" size="small" style="width:100%" @change="syncPaymentMoneyFromWriteOff" />
          </template>
        </el-table-column>
        <el-table-column v-if="!readonly" label="操作" width="60" align="center">
          <template slot-scope="scope"><el-button type="text" size="small" @click="removeWriteoffLine(scope.$index)">删</el-button></template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
    </span>
    <SupplierSelector :visible.sync="picker" @select="onPick" />
    <FinanceWriteoffSelector :visible.sync="writeoff" :partner-id="form.supplierId" :exclude-id="form.id || ''" :receipt="false" @select="onWriteoff" />
  </el-dialog>
</template>

<script>
import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'
import SupplierSelector from '../../components/SupplierSelector.vue'
import FinanceWriteoffSelector from '../../components/FinanceWriteoffSelector.vue'
import DictSelectWithAdd from '../../components/DictSelectWithAdd.vue'
import request from '../../api/request'
import auth from './financeAuth'

export default {
  name: 'PaymentAddOrUpdate',
  mixins: [auth],
  components: { WorkflowDocButtons, SupplierSelector, FinanceWriteoffSelector, DictSelectWithAdd },
  data() {
    return {
      visible: false,
      readonly: false,
      codeReadonly: false,
      picker: false,
      writeoff: false,
      subjects: [],
      form: this.blank(),
      rules: {
        code: [{ required: true, message: '付款单号不能为空', trigger: 'blur' }],
        bizDate: [{ required: true, message: '付款日期不能为空', trigger: 'change' }],
        supplierId: [{ required: true, message: '供应商不能为空', trigger: 'change' }],
        cashSubjectId: [{ required: true, message: '请选择入账科目', trigger: 'change' }]
      }
    }
  },
  computed: {
    formRules() {
      return this.codeReadonly ? { bizDate: this.rules.bizDate, supplierId: this.rules.supplierId, cashSubjectId: this.rules.cashSubjectId } : this.rules
    },
    dialogTitle() {
      if (this.readonly) return '查看付款单'
      return this.form.id ? '修改付款单' : '新增付款单'
    },
    writeOffTotal() {
      return (this.form.lines || []).reduce((s, l) => s + Number(l.writeOffMoney || 0), 0).toFixed(2)
    },
    invalidSourceCount() { return (this.form.lines || []).filter(line => line.sourceInvalid).length },
    cashSubjects() {
      const type = String(this.form.settleType || '')
      const prefix = type.includes('现金') ? '1001' : type.includes('承兑') ? '2201' : '1002'
      return this.subjects.filter(s => String(s.isLeaf) === '1' && String(s.isenabled) === '0' && String(s.subjectCode).startsWith(prefix))
    }
  },
  methods: {
    loadSubjects() { request.get('/finance/subject/list').then(res => { this.subjects = res.data || [] }).catch(() => {}) },
    blank() {
      return { kind: 'payment', code: '', bizDate: this.today(), supplierId: '', partnerName: '', money: 0, settleType: '', accountName: '', cashSubjectId: '', discountMoney: 0, lines: [] }
    },
    init(id, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.codeReadonly = false
      this.picker = false
      this.writeoff = false
      this.loadSubjects()
      if (!id) {
        this.form = this.blank()
        this.resolveCode()
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
        return
      }
      request.get('/finance/cash/info', { params: { kind: 'payment', id } }).then(res => {
        const row = res.data || {}
        this.form = Object.assign({ kind: 'payment', lines: [] }, row)
        if (!Array.isArray(this.form.lines)) this.form.lines = []
        if (typeof this.loadSources === 'function') this.loadSources()
        if (typeof this.loadSubjects === 'function') this.loadSubjects()
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    onClosed() {
      this.form = this.blank()
      this.readonly = false
      this.codeReadonly = false
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'payment' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.form.code = data.previewCode
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate('code'))
      }).catch(() => {})
    },
    editFromView() {
      if (!this.assertCanEditDoc('edit')) return
      this.readonly = false
    },
    deleteFromView() {
      if (!this.assertCanEditDoc('delete')) return
      this.$confirm('确定删除该付款单?', '提示', { type: 'warning' }).then(() => {
        request.post('/finance/cash/delete', { kind: 'payment', id: this.form.id }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },
    onPick(row) { this.form.supplierId = row.supplierId; this.form.partnerName = row.supplierName; this.form.lines = [] },
    onWriteoff(rows) {
      rows.forEach(row => {
        const invoice = row.writeOffType === 'invoice'
        const opening = row.writeOffType === 'opening'
        this.form.lines.push({
          billCode: row.billCode,
          materialName: row.materialName,
          remainAmount: row.remainAmount,
          purchaseInvoiceId: invoice ? row.billId : '',
          payableId: invoice || opening ? '' : row.billId,
          payableLineId: invoice || opening ? '' : row.billLineId,
          openingSupplierId: opening ? row.billId : '',
          writeOffMoney: Number(row.remainAmount || 0)
        })
      })
      this.syncPaymentMoneyFromWriteOff()
    },
    removeWriteoffLine(index) {
      this.form.lines.splice(index, 1)
      this.syncPaymentMoneyFromWriteOff()
    },
    syncPaymentMoneyFromWriteOff() {
      this.form.money = Number(this.writeOffTotal)
    },
    onWorkflowDone() {
      this.$emit('refreshDataList')
      if (this.form && this.form.id) this.init(this.form.id, true)
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!this.form.lines.length) { this.$message.warning('请至少添加一条核销明细'); return }
        request.post('/finance/cash/save', this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    },
    approve(row, pass) {
      const url = pass ? '/finance/cash/approve' : '/finance/cash/unapprove'
      this.$confirm(pass ? '确定审核?' : '确定弃审?', '提示', { type: 'warning' }).then(() => {
        request.post(url, { kind: 'payment', id: row.id }).then(() => {
          this.$message.success(pass ? '审核成功' : '弃审成功')
          if (row && this.form && ((row.id && this.form.id === row.id) || (row.voucherId && this.form.voucherId === row.voucherId))) {
            this.$set(this.form, 'approveStatus', pass ? '2' : '0')
            this.readonly = true
          }
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.source-warning { margin-bottom: 12px; }
.source-error { color: #e6a23c; font-weight: 600; }
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
.discount-hint { color: #909399; font-size: 12px; line-height: 18px; }
</style>
